import React, { Component } from 'react';
import RegisterForm from '../registerForm/registerForm';
import $ from 'jquery';

class DowloadModal extends Component {
  static propTypes = {

  };

  closeModal = () => {
    $('#dowloadModal').modal('hide');
  }

  render() {
    return (
      <div className="modal bd-example-modal-lg livison-modal" role="dialog" id="contactModal">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title">联系我们</h5>
              <p className="instructions">请填写基本信息,已便我们能够联系到您</p> 
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <RegisterForm type={'contact'}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DowloadModal;